import {userService} from "../_services";
import {authenticationState} from "../_constants/commons/authenticationState";
import {Stack} from "mnemonist";

/**
 * This service adds the following functionality
 */
export const stateInitializer = {
  getInitialStateForStore,
  getAuthInitialStates,
  getUserInitialStates,
  getHistoryInfoInitialState,
};

/**
 * Returns the initial state for the authentication reducer
 *
 * @returns {*} initial state
 */
function getAuthInitialStates () {
  const initialUser = userService ? userService.getAuthUser() : undefined;  // fetch from storage
  return initialUser ?
      {authState: authenticationState.LOGGED_IN, user: initialUser} : {authState: authenticationState.NOT_LOGGED_IN};
}

/**
 * Returns the initial state for the users reducer
 *
 * @returns {*} initial state
 */
function getUserInitialStates() {
  const initialUserDetails = userService ? userService.getUserDetails() : undefined;  // fetch from storage
  return initialUserDetails
      ? {info: {details: initialUserDetails}}
      : {};
}

/**
 * Returns the initial state for the historyInfo reducer
 *
 * @returns {*} initial state
 */
function getHistoryInfoInitialState() {
  return {
    list: {
      current: null,
      back: new Stack(),
      forward: new Stack(),
    },
    isDomainSafe: false
  };
}

/**
 * Prepares all the default initial state fot all the reducers
 *
 * @returns {{historyInfo: *, users: *, authentication: *}}
 */
function getInitialStateForStore() {
  return {
    authentication    : getAuthInitialStates(),
    users             : getUserInitialStates(),
    historyInfo       : getHistoryInfoInitialState(),
  };
}